import rentlineEnv from './RentlineEnvs.json';

export const ENVS = rentlineEnv;